/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/imagepane/imagepane_styles';



/* ========== ~~~~~~~~~~ IMAGE API : IMAGE PANE ~~~~~~~~~~ ========== */
const ImagePane = (props) => {
	return (
		<div className={`imagepane ${props.classes.imagepane}`}>
        	{props.children}
        </div>
	);
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ImagePane);
